export default __webpack_public_path__ + "static/media/2AB5JNR.6fc77640.jpg";